import PropTypes from "prop-types";
import React from "react";

const WorkingHoursDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Working Hour Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive" >
            <table className="table ">
              <thead>
                <tr>
                  <th>Monday</th>
                  <th>Tuesday</th>
                  <th>Wednesday</th>
                  <th>Thursday</th>
                  <th>Friday</th>
                  <th>Saturday</th>
                  <th>Sunday</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{employee?.monday}</td>
                  <td>{employee?.tuesday}</td>
                  <td>{employee?.wednesday}</td>
                  <td>{employee?.thursday}</td>
                  <td>{employee?.friday}</td>
                  <td>{employee?.saturday}</td>
                  <td>{employee?.sunday}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkingHoursDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default WorkingHoursDetails;
